import { scalePow, scaleSymlog } from "victory-vendor/d3-scale"

import type { ComparisonPlotScale } from "@/utils/comparisonPlot"

export const DEFAULT_POW_EXPONENT = 2

// The value Recharts' `scale` prop expects: a scale-name string for the natively
// supported scales, or a raw d3 scale where Recharts has no usable string.
// "log" -> symlog (Recharts has no "symlog" string; tolerates zero/negatives).
// "pow" -> scalePow with the exponent applied (the "pow" string is silently
// linear because Recharts leaves the exponent at 1).
export function resolveScale(scale?: ComparisonPlotScale, exponent?: number) {
  if (scale === "log") {
    return scaleSymlog()
  }
  if (scale === "sqrt") {
    return "sqrt" as const
  }
  if (scale === "pow") {
    return scalePow().exponent(
      typeof exponent === "number" && exponent > 0
        ? exponent
        : DEFAULT_POW_EXPONENT,
    )
  }
  return "linear" as const
}
